
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#gst-tenants-aadvantagehotels-app-modules-hotel-assets-svg-amenities-day-care_svg-a)","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M12 18.501v5"}}),_c('path',{attrs:{"d":"M14.75 22a.25.25 0 01.231.154.25.25 0 01-.054.273.25.25 0 01-.273.054.25.25 0 01-.154-.231.25.25 0 01.25-.25zm0-3a.25.25 0 01.231.154.25.25 0 01-.054.273.25.25 0 01-.273.054.25.25 0 01-.154-.231.25.25 0 01.25-.25z","fill":"#50657c"}}),_c('path',{attrs:{"d":"M12 4.501v-2m-1 1h2M23.5 23.5v-1a4 4 0 00-2.6-3.745L16 17.11m-8 0l-4.9 1.646A4 4 0 00.5 22.5v1M6 7.708a15.519 15.519 0 0112 0M10.5 13a2.175 2.175 0 003 0M11 9a1.089 1.089 0 00-1-.5A1.089 1.089 0 009 9m6 0a1.089 1.089 0 00-1-.5 1.09 1.09 0 00-1 .5m-7.275 1.572a5.148 5.148 0 01-1.954 3.147.5.5 0 00-.243.405.5.5 0 00.202.426 4.427 4.427 0 002.915.932M18.3 10.514a5.2 5.2 0 001.97 3.205.5.5 0 01.242.405.5.5 0 01-.202.426 4.425 4.425 0 01-2.915.932"}}),_c('path',{attrs:{"d":"M18 8.511v-5.4a2 2 0 00-1.4-1.909 15.508 15.508 0 00-9.19 0A2 2 0 006 3.108v5.4c-.846.456-.572 2.392.5 2.878a1 1 0 01.572.746C7.513 14.781 10.614 16.5 12 16.5c1.387 0 4.488-1.722 4.93-4.366a1 1 0 01.571-.746c1.07-.488 1.344-2.419.499-2.877z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"gst-tenants-aadvantagehotels-app-modules-hotel-assets-svg-amenities-day-care_svg-a"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    